import {Component, Input, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {NzMessageService} from 'ng-zorro-antd/message';
import {TaskService} from '../../services/task.service';
import * as JsEncryptModule from 'jsencrypt';

@Component({
  selector: 'nf-task-progress',
  templateUrl: './task-progress.component.html',
  styleUrls: ['./task-progress.component.css']
})
export class TaskProgressComponent implements OnInit {
  dataSubscription: Subscription = null;
  boardData: any = {}; // 面板数据
  boardId: string;
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  currentUser: any; // 当前登录用户
  group: any = {}; // 当前组件分组数据
  pulse: any = {}; // 当前组件行数据
  column: any = {}; // 当前组件列数据
  isDisabled = false;
  popVisible = false;
  editing = false;
  isVisible = false;
  statusWidth = 135; // 标签组件下拉框动态宽度
  isAuth = false; // 标志置任务状态是否需要授权
  statusEvent: string; // 置状态触发事件
  isAuthVisible = false;
  isCompleteVisible = false;
  isDelayVisible = false;
  authorizedValue = ''; // 授权人员
  authorizedPassword: string; // 授权人员密码
  operator = ''; // 操作人员
  reason = ''; // 操作原因
  delayDate: any; // 任务延期日期
  currentPulse: any;
  currentStatus: any;
  currentColumn: any;
  remarksVisible = false;
  progress = 0;
  publicKey: string;
  taskDef: any; // 任务规则数据
  preTaskId = []; // 前置任务ID
  nfDisabled = false;
  @Input('nfBoardData') set ChangeBoardData(data: any) {
    if (data) {
      this.boardData = data;
      this.boardId = data.id;
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
      this.currentUser = this.boardData.boardData.currentUser ? this.boardData.boardData.currentUser : {};
    }
  }
  @Input('nfColumnData') set ChangeColumnData(data: any) {
    if (data) {
      this.column = data;
    }
  }
  @Input('nfPulseData') set ChangePulseData(data: any) {
    if (data) {
      this.pulse = this.duplicateRemoval(data);
      if (this.pulse.taskDef) {
        this.taskDef = this.pulse.taskDef;
        this.preTaskId = this.taskDef.preTaskDefId ? this.taskDef.preTaskDefId.split(',') : null;
      }
    }
  }
  @Input('nfDisabled') set ChangeDisabled(val: boolean) {
    this.nfDisabled = val;
  }
  constructor(
    private taskService: TaskService,
    private message: NzMessageService
  ) { }

  ngOnInit(): void {
    this.handleParentProgress(this.pulse, this.column.id);
  }
  // 计算标签组件框宽度
  getStatusWidth(label, type?: any) {
    const len = label.length + 1;
    const width = 134;
    if (len > 4) {
      this.statusWidth = Number.isInteger(len / 4) ? len / 4 * width : Math.ceil(len / 4) * width;
    } else {
      this.statusWidth = width;
    }
    return {'width': this.statusWidth + 'px'};
  }
  changeStatus(pulse, status, column) {
    this.currentPulse = pulse;
    this.currentStatus = status;
    this.currentColumn = column;
    // 前置任务处理
    if (pulse.taskDef && pulse.taskDef.preTaskDefId) {
      const backVal = this.preTaskHandle(this.boardPulseData);
      if (!backVal.status) {
        this.message.create('warning', '请先完成前置任务：' + backVal.title);
        return false;
      }
    }
    // 置任务是否需要审核
    this.isAuth = pulse.taskDef && pulse.taskDef.isAuth === '1' ? true : false;
    // 置任务事件
    this.statusEvent = status.event ? status.event : '';
    // 是否需要授权
    if (this.isAuth) {
      // 需要授权进去授权窗口
      this.getPublicKey();
      this.isAuthVisible = true;
      this.authorizedValue = '';
      this.authorizedPassword = '';
    } else {
      // 无需授权匹配是否有选中事件
      this.taskEventHandle();
    }
  }
  // 前置任务处理
   preTaskHandle(data: Array<any>) {
    let flag = true;
    let taskTitle: string;
    data.forEach(item => {
      this.preTaskId.forEach(_per => {
        if (item.taskDef && item.taskDef.id) {
          if (_per === item.taskDef.id) {
            if (!(item.columnValues[this.currentColumn.id] && (item.columnValues[this.currentColumn.id].progress === 100) || item.columnValues[this.currentColumn.id].symbol === 'complete' || (item.columnValues[this.currentColumn.id].value && item.columnValues[this.currentColumn.id].value.symbol === 'complete'))) {
              flag = false;
              taskTitle = item.name;
            }
          }
        }
      });
      // if (item.children) {
      //   this.preTaskHandle(item.children);
      // }
    });
    const backVal = {
      title: taskTitle,
      status: flag
    };
    return backVal;
  }
  // 任务事件处理
  taskEventHandle() {
    if (this.statusEvent === 'forceCompletion') {
      // 强制完成
      this.isCompleteVisible = true;
      this.operator = '';
      this.reason = '';
    } else if (this.statusEvent === 'delay') {
      // 延期
      this.isDelayVisible = true;
      this.delayDate = null;
    } else {
      let val = this.currentPulse.columnValues[this.currentColumn.id];
      // let val = {};
      const param = {};
      if (val === 'null' || !val) {
        val = {
          value: this.currentStatus
        };
      } else {
        val['value'] = this.currentStatus;
      }
      val['operationType'] = 'manual';
      param['pulseIds'] = [this.currentPulse.id];
      param['columnId'] = this.currentColumn.id;
      param['columnValue'] = val;
      this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
        this.taskStatusChange(this.currentPulse, this.currentStatus, this.currentColumn);
      });
      // 更新父级任务进度
      if (this.currentPulse.parentId) {
        const _param = {};
        _param['pulseIds'] = [this.currentPulse.parentId];
        _param['columnId'] = this.currentColumn.id;
        _param['columnValue'] = {
          progress: this.progress,
          operationType: 'manual'
        };
        this.dataSubscription = this.taskService.doEditPulse(this.boardId, _param).subscribe((res: any) => {});
      }
    }
  }
  // 置任务状态
  taskStatusChange(pulse, status, column) {
    // 任务状态选中项赋值
    if (this.pulse.columnValues[column.id] === 'null' || !this.pulse.columnValues[column.id]) {
      this.pulse.columnValues[column.id] = {
        value: status
      };
    } else {
      this.pulse.columnValues[column.id].value = status;
    }
    this.boardPulseData.forEach(item => {
      if (item.id === this.pulse.id) {
        item.columnValues[column.id] = {
          value: status
        };
      }
    });
    this.popVisible = false;
    // 计算进度
    this.handleProgress(pulse, column.id);
    // 设置当前处理人
    let handlerColumnId = '';
    this.boardColumnData.forEach(item => {
      if (item.type === 'handler') {
        handlerColumnId = item.id;
      }
    });
    // 保留会签多人记录接口
    if (pulse.columnValues[handlerColumnId] && pulse.columnValues[handlerColumnId].personsAndTeams) {
      pulse.columnValues[handlerColumnId].personsAndTeams.forEach(item => {
        if (item.id !== this.currentUser.id) {
          // pulse.columnValues[handlerColumnId].personsAndTeams.push(this.currentUser);
          pulse.columnValues[handlerColumnId].personsAndTeams = [this.currentUser];
        }
      });
      const param = {};
      param['pulseIds'] = [this.currentPulse.id];
      param['columnId'] = handlerColumnId;
      param['columnValue'] = pulse.columnValues[handlerColumnId];
      param['columnValue']['operationType'] = 'manual';
      this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {});
    } else {
      if (!pulse.columnValues[handlerColumnId]) {
        const personsAndTeams = [this.currentUser];
        pulse.columnValues[handlerColumnId] = {
          'personsAndTeams': personsAndTeams
        };
      }
      if (pulse.columnValues[handlerColumnId] === 'null') {
        pulse.columnValues[handlerColumnId] = {
          personsAndTeams: [this.currentUser]
        };
      } else {
        pulse.columnValues[handlerColumnId].personsAndTeams = [this.currentUser];
      }
      const param = {};
      param['pulseIds'] = [this.currentPulse.id];
      param['columnId'] = handlerColumnId;
      param['columnValue'] = pulse.columnValues[handlerColumnId];
      param['columnValue']['operationType'] = 'manual';
      this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {});
    }
    // 更新父级任务进度
    if (this.currentPulse.parentId) {
      const _param = {};
      _param['pulseIds'] = [this.currentPulse.parentId];
      _param['columnId'] = this.currentColumn.id;
      _param['columnValue'] = {
        progress: this.progress,
        operationType: 'manual'
      };
      this.dataSubscription = this.taskService.doEditPulse(this.boardId, _param).subscribe((res: any) => {
      });
    }
  }
  // 计算父级进度
  handleProgress(data, columnId) {
    if (data.parent && data.parentId === data.parent.id) {
      if (data.parent.children && data.parent.children.length) {
        let num = 0;
        data.parent.children.forEach(item => {
          if (item.columnValues[columnId]) {
            if (item.columnValues[columnId].value && item.columnValues[columnId].value.symbol === 'complete') {
              num += 1;
            } else if (item.columnValues[columnId].progress && item.columnValues[columnId].progress === 100) {
              num += 1;
            }
          }
        });
        const progress = Math.round((num / data.parent.children.length) * 100);
        if (data.parent.columnValues[columnId]) {
          data.parent.columnValues[columnId].progress = progress;
        } else {
          data.parent.columnValues[columnId] = {
            progress: progress
          };
        }
        if (data.parent.parent) {
          this.handleProgress(data.parent, columnId);
        }
        this.progress = progress;
      }
    }
  }
  // 渲染完第一次处理父级进度
  handleParentProgress(data, columnId) {
    if (data.children) {
      let num = 0;
      data.children.forEach(child => {
        if (child.columnValues[columnId]) {
          if (child.columnValues[columnId].value && child.columnValues[columnId].value.symbol === 'complete') {
            num += 1;
          } else if (child.columnValues[columnId].progress && child.columnValues[columnId].progress === 100) {
            num += 1;
          }
        }
      });
      const progress = Math.round((num / data.children.length) * 100);
      if (data.columnValues[columnId] === 'null') {
        data.columnValues[columnId] = {
          progress: progress
        };
      } else {
        data.columnValues[columnId].progress = progress;
      }
      if (data.children.children) {
        this.handleParentProgress(data.children, columnId);
      }
      this.progress = progress;
    }
  }
  // 去重
  duplicateRemoval(data) {
    const _data = data;
    if (_data.children && _data.children.length) {
      const obj = {};
      _data.children = _data.children.reduce((cur, next) => {
        obj[next.id] ? '' : obj[next.id] = true && cur.push(next);
        return cur;
      }, []);
      _data.children.forEach(item => {
        if (item.children && item.children.length) {
          this.duplicateRemoval(item.children);
        }
      });
    }
    return _data;
  }
  // 授权操作
  handleAuthOk() {
    if (this.authorizedValue && this.authorizedPassword) {
      const loginUserSrt = localStorage.getItem('profile');
      let loginUser: any;
      if (loginUserSrt !== 'null') {
        loginUser = JSON.parse(loginUserSrt);
      }
      if (loginUser && loginUser.userId === this.authorizedValue) {
        this.message.create('warning', '不能给自己授权！');
        return;
      }
      // 校验登录
      const loginParam = {
        username: this.authorizedValue,
        password: this.encodePassword(this.authorizedPassword)
      };
      this.dataSubscription = this.taskService.login(loginParam).subscribe((res: any) => {
        this.isAuthVisible = false;
        // 提交授权人员信息
        if (this.statusEvent) {
          // 有状态事件
          const val = this.currentPulse.columnValues[this.currentColumn.id];
          // const val = {};
          const param = {};
          val['operationType'] = 'manual';
          val['authorizedValue'] = this.authorizedValue;
          val['value'] = this.currentStatus;
          param['pulseIds'] = [this.currentPulse.id];
          param['columnId'] = this.currentColumn.id;
          param['columnValue'] = val;
          // 下一步强制完成原因
          this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
            this.taskEventHandle();
          });
        } else {
          // 没有状态事件
          // 直接置状态 提交当前选中状态
          const val = this.currentPulse.columnValues[this.currentColumn.id];
          // const val = {};
          const param = {};
          val['authorizedValue'] = this.authorizedValue;
          val['value'] = this.currentStatus;
          val['operationType'] = 'manual';
          param['pulseIds'] = [this.currentPulse.id];
          param['columnId'] = this.currentColumn.id;
          param['columnValue'] = val;
          this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
            this.taskStatusChange(this.currentPulse, this.currentStatus, this.currentColumn);
          });
          // 更新父级任务进度
          if (this.currentPulse.parentId) {
            const _param = {};
            _param['pulseIds'] = [this.currentPulse.parentId];
            _param['columnId'] = this.currentColumn.id;
            _param['columnValue'] = {
              progress: this.progress,
              operationType: 'manual'
            };
            this.dataSubscription = this.taskService.doEditPulse(this.boardId, _param).subscribe((res: any) => {
            });
          }
        }
      }, (err) => {
        // this.message.create('error', '授权校验失败!');
      });
    } else {
      this.message.create('warning', '必填项不能为空！');
    }
  }
  handleAuthCancel() {
    this.isAuthVisible = false;
  }
  // 强制完成操作
  handleCompleteOk() {
    if (this.reason) {
      this.isCompleteVisible = false;
      const val = this.currentPulse.columnValues[this.currentColumn.id];
      // const val = {};
      const param = {};
      val['remarks'] = {
        reason: this.reason
      };
      val['value'] = this.currentStatus;
      val['operationType'] = 'manual';
      if (this.authorizedValue) {
        val['authorizedValue'] = this.authorizedValue;
      }
      param['pulseIds'] = [this.currentPulse.id];
      param['columnId'] = this.currentColumn.id;
      param['columnValue'] = val;
      this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
        this.taskStatusChange(this.currentPulse, this.currentStatus, this.currentColumn);
      });
    } else {
      this.message.create('warning', '必填项不能为空！');
    }
  }
  handleCompleteCancel() {
    this.isCompleteVisible = false;
  }
  // 延期操作
  handleDelayOk() {
    if (this.delayDate) {
      // 修改任务日期
      const param = {
        periodAt: this.delayDate.getTime()
      };
      this.taskService.delayTask(this.currentPulse.id, param).subscribe((res) => {
        // 置状态
        const val = this.currentPulse.columnValues[this.currentColumn.id];
        // const val = {};
        const _param = {};
        val['value'] = this.currentStatus;
        val['operationType'] = 'manual';
        if (this.authorizedValue) {
          val['authorizedValue'] = this.authorizedValue;
        }
        _param['pulseIds'] = [this.currentPulse.id];
        _param['columnId'] = this.currentColumn.id;
        _param['columnValue'] = val;
        this.dataSubscription = this.taskService.doEditPulse(this.boardId, _param).subscribe((_res: any) => {
          this.isDelayVisible = false;
          this.taskStatusChange(this.currentPulse, this.currentStatus, this.currentColumn);
        });
      });
    } else {
      this.message.create('warning', '必填项不能为空！');
    }
  }
  handleDelayCancel() {
    this.isDelayVisible = false;
  }
  // 查看完成详情
  openRemarksDialog(event) {
    event.stopPropagation();
    this.remarksVisible = true;
  }
  handleRemarksCancel() {
    this.remarksVisible = false;
  }
  // 加密
  encodePassword(password) {
    const pubkey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDXPnPsZPEVcaiZJXYydRgpr8SE\n' +
      '5QMZqL7TQA3n1U9cqAoJSSgJ25hwqUon83KCTysWh+Jzd1kLND42zIgIHGpjt6Oe\n' +
      '+GqoBhBQFBkP4kWIQvNb2PdsQtX/svdM5J8IYE/gCTt0FLKnZc/PA4BtL3xgcw20\n' +
      'MbZEUDe2mkAxc6ofMQIDAQAB';
    const encrypt = new JsEncryptModule.JSEncrypt();
    if (this.publicKey) {
      encrypt.setPublicKey(this.publicKey);
      return encrypt.encrypt(password);
    } else {
      encrypt.setPublicKey(pubkey);
      return encrypt.encrypt(password);
    }
  }
  // 获取公钥
  getPublicKey() {
    this.dataSubscription = this.taskService.getPublicKey().subscribe((res: any) => {
      if (res) {
        this.publicKey = res.content.publicKey;
      }
    });
  }
  // 格式化进度
  formatProgress = (percent: number) => `${percent}%`;
}
